import gsap from 'gsap';
import EventDispatcher from '../../common/EventDispatcher';
import { Global } from '../../common/global';

export default class Instruction {
  constructor() {
    // document
    //   .querySelector('#proceedBtn')
    //   .addEventListener('click', this.startGame.bind(this));
  }
  init() {
    this.isVisible = false;
    this.proceeded = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
      case 'hide_home':
        this.hideScreen(data['message']['data']);
        break;
    }
  }
  hideScreen(data) {
    if (!this.isVisible) return;
    if (data && data['screenKey'] !== 'Instruction') return false;

    this.isVisible = false;
    // this.introRotateTwn.kill();

    document.querySelector(`#instrScr #instr`).classList.remove('active');
    gsap.delayedCall(0.1, () => {
      document.querySelector('#instrScr').classList.remove('active');
    });
    gsap.delayedCall(0.5, () => {
      document.querySelector('#instrScr').classList.remove('active2');
    });
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Instruction') return false;

    this.isVisible = true;
    document.querySelector('#instrScr').classList.add('active');

    gsap.delayedCall(0.5, () => {
      document.querySelector('#instrScr').classList.add('active2');
      //   document.querySelector('#instrScr .title').classList.add('active');
    });
    gsap.delayedCall(0.2, this.animate.bind(this));
  }
  animate() {
    document.querySelector('#counter3').classList.remove('active');
    document.querySelector('#counter2').classList.remove('active');
    document.querySelector('#counter1').classList.remove('active');
    document.querySelector('#countergo').classList.remove('active');
    this.counterIndex = 4;

    this.counterTI = setInterval(() => {
      this.counterIndex--;
      document.querySelector('#counter3').classList.remove('active');
      document.querySelector('#counter2').classList.remove('active');
      document.querySelector('#counter1').classList.remove('active');
      document.querySelector('#countergo').classList.remove('active');

      if (this.counterIndex == 3 && Global.gameTry == 0) {
        document.querySelector(`#instrScr #instr`).classList.add('active');
      } else if (this.counterIndex == 3 && Global.gameTry != 0) {
        document.querySelector(`#instrScr .counter`).classList.add('mid');
      }
      if (this.counterIndex == 0) {
        clearInterval(this.counterTI);
        document.querySelector(`#countergo`).classList.add('active');
        gsap.delayedCall(0.75, () => {
          this.hideScreen();
          this.events.dispatchEvent({
            type: 'GAMESCENE_EVENTS',
            message: { event_type: 'start_game', data: {} },
          });
        });
      } else {
        document
          .querySelector(`#counter${this.counterIndex}`)
          .classList.add('active');
      }

      gsap.fromTo(
        '#instrScr .counter',
        { scale: 0 }, // Start state
        {
          scale: 1, // End state
          duration: 0.3,
          ease: 'back.out(1.7)',
        }
      );
    }, 1000);
  }
  startGame() {
    if (this.proceeded) return;
    this.proceeded = true;

    Global.animateButton.call(
      this,
      document.querySelector('#instrScr #proceedBtn'),
      true
    );
    Global.isGameActive = true;
    this.hideScreen();

    this.events.dispatchEvent({
      type: 'GAMESCENE_EVENTS',
      message: { event_type: 'start_game', data: {} },
    });
  }
}
